var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuiltInCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "104px",
    viewBox: "0 0 98 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pressure",
    transform: "translate(-11.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG-Circle",
    fill: "#EDEFF3",
    fillRule: "nonzero",
    cx: 59.906,
    cy: 63.537508,
    r: 48.906
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5726131,82.7771436 L60.244492,65.114948 L91.6452328,82.6268996 C94.5730408,84.1883972 96.3652142,87.0748019 96.4711422,90.368429 L96.4763821,90.6783716 L96.4763821,96.0098936 C87.5178965,106.0916 74.4537321,112.443508 59.906,112.443508 C45.7200928,112.443508 32.9448737,106.403634 24.0116314,96.7551749 L24.012868,90.6783716 C24.012868,87.3601892 25.7163199,84.4205517 28.5726131,82.7771436 L28.5726131,82.7771436 Z",
    id: "Camera-Stand",
    fill: "#D4DCE6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Color",
    cx: 60.244492,
    cy: 45,
    r: 36,
    fill: "#ff4d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.244492,22.858452 C71.0979347,22.858452 80.1274565,30.6675853 82.0208375,40.9736319 L96.270228,40.974264 L96.270228,49.025736 L82.0208375,49.0263681 C80.1274565,59.3324147 71.0979347,67.141548 60.244492,67.141548 C49.3910493,67.141548 40.3615275,59.3324147 38.4681465,49.0263681 L24.218756,49.025736 L24.218756,40.974264 L38.4681465,40.9736319 C40.3615275,30.6675853 49.3910493,22.858452 60.244492,22.858452 Z",
    id: "Camera",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.212322,33.1240788 L55.212322,33.1240788 C60.244492,30.909924 66.4843828,32.1176448 70.308832,36.948528 C72.7242736,39.7665432 73.5294208,43.7922792 72.9255604,47.4154416 C71.315266,56.070774 62.0560732,60.09651 54.8097484,56.6746344 C48.3685708,53.6553324 45.7518424,45.8051472 48.7711444,39.5652564 L48.7711444,39.5652564 C52.5955936,40.7729772 56.4200428,37.1498148 55.212322,33.1240788 Z",
    id: "Lens",
    fill: "#000F38",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltInCamera);
export default __webpack_public_path__ + "static/media/built-in-camera.d91bf976f9e0203d14b25033c9a31fe7.svg";
export { ForwardRef as ReactComponent };